import { Fancybox } from "@fancyapps/ui";
import { fancyboxConfig } from 'js/config';

export default class ProductImages {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.triggers = Array.from(document.querySelectorAll('[data-product-images-trigger]'));
        this.images = JSON.parse(this.DOM.el?.dataset?.productImages || '[]');

        this.initEvents();
    }

    initEvents() {
        this.DOM.triggers.forEach((trigger) => trigger.addEventListener('click', this.openFancybox));
    }

    openFancybox = (event) => {
        const trigger = event.currentTarget;
        const index = trigger?.dataset?.productImagesTrigger || 0;

        Fancybox.show(
            this.images?.map((image) => ({
                src: image.image,
                thumb: image.thumbnail,
                type: 'image',
            })),
            {
                ...fancyboxConfig,
                startIndex: index,
            }
        );
    }
}

const productImagesNodes = Array.from(document.querySelectorAll('[data-product-images]'));
if (productImagesNodes !== null) {
    productImagesNodes.forEach((node) => { new ProductImages(node); });
}
